module.exports = __webpack_public_path__ + "static/media/sudaneze-orgs.2cd4dba5.svg";